// Local wall-clock time, with round-trip validation (including DST gaps).
export function parseDateTimeInput(dateText: string, timeText: string): Date | null {
  const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateText);
  const time = /^(\d{2}):(\d{2})$/.exec(timeText);
  if (!date || !time) return null;
  const [year, month, day] = date.slice(1).map(Number);
  const [hour, minute] = time.slice(1).map(Number);
  const value = new Date(0);
  value.setFullYear(year, month - 1, day);
  value.setHours(hour, minute, 0, 0);
  return value.getFullYear() === year && value.getMonth() === month - 1
    && value.getDate() === day && value.getHours() === hour && value.getMinutes() === minute
    ? value : null;
}
